import { render } from "./AppServices.vue?vue&type=template&id=73163642&scoped=true"
import script from "./AppServices.vue?vue&type=script&lang=js"
export * from "./AppServices.vue?vue&type=script&lang=js"

import "./AppServices.vue?vue&type=style&index=0&id=73163642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73163642"]])

export default __exports__